module.exports = __webpack_public_path__ + "img/ifmAsset.38dc8011.svg";